// extracted by mini-css-extract-plugin
export default {"div":"ItemPoster_div__Jw27Z"};